export const generateUniqueKey = (prefix, existingDict) => {
  let index = 1;
  let key = `${prefix}_${index}`;
  
  // Find the next available index
  while (existingDict.hasOwnProperty(key)) {
    index++;
    key = `${prefix}_${index}`;
  }
  
  return key;
};
